import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap, take } from 'rxjs/operators';

import { WkKeywordService } from '../../services/wk-keyword.service';
import { AppStore, IKeyWord } from '../states';
import {
  GET_DOCUMENT_KEYWORD,
  GetKeyWordAction,
  SetKeyWordAction,
} from '../actions/app.custom-actions';
@Injectable()
export class KeywordEffects {
  constructor(
    private readonly store: Store<AppStore>,
    private readonly actions$: Actions,
    private readonly keywordService: WkKeywordService
  ) {}

  loadKeyword$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<GetKeyWordAction>(GET_DOCUMENT_KEYWORD),
        switchMap((action) =>
          this.keywordService.getKeyWordData(action.payload.nodeId).pipe(
            take(1),
            map((response: { keyWords: IKeyWord[] }) =>
              this.store.dispatch(new SetKeyWordAction(response.keyWords))
            )
          )
        )
      ),
    { dispatch: false }
  );
}
